import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "fw-medium text-muted fs-13 d-block mb-5" }
const _hoisted_6 = { class: "row mt-20 mb-20" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "filter-card p-20 border rounded bg-light" }
const _hoisted_9 = { class: "row align-items-end" }
const _hoisted_10 = { class: "col-lg-4 col-md-6 mb-15 mb-lg-0" }
const _hoisted_11 = ["max"]
const _hoisted_12 = { class: "col-lg-4 col-md-6 mb-15 mb-lg-0" }
const _hoisted_13 = ["min", "max"]
const _hoisted_14 = { class: "col-lg-4 col-md-12" }
const _hoisted_15 = { class: "d-flex gap-10" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "row mt-20"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-xl-3 col-lg-3 col-xxxl-3 col-sm-3" }
const _hoisted_21 = { class: "card mb-25 border rounded bg-white stats-box" }
const _hoisted_22 = { class: "card-body pe-10 ps-10 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15 py-3" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "title ms-15" }
const _hoisted_25 = { class: "fw-black mb-8 lh-1" }
const _hoisted_26 = { class: "col-xl-3 col-lg-3 col-xxxl-3 col-sm-3" }
const _hoisted_27 = { class: "card mb-25 border rounded bg-white stats-box" }
const _hoisted_28 = { class: "card-body pe-10 ps-10 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15 py-3" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "title ms-15" }
const _hoisted_31 = { class: "fw-black mb-8 lh-1" }
const _hoisted_32 = { class: "col-xl-3 col-lg-3 col-xxxl-3 col-sm-3" }
const _hoisted_33 = { class: "card mb-25 border rounded bg-white stats-box" }
const _hoisted_34 = { class: "card-body pe-10 ps-10 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15 py-3" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "title ms-15" }
const _hoisted_37 = { class: "fw-black mb-8 lh-1" }
const _hoisted_38 = { class: "col-xl-3 col-lg-3 col-xxxl-3 col-sm-3" }
const _hoisted_39 = { class: "card mb-25 border rounded bg-white stats-box" }
const _hoisted_40 = { class: "card-body pe-10 ps-10 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15 py-3" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "title ms-15" }
const _hoisted_43 = { class: "fw-black mb-8 lh-1" }
const _hoisted_44 = { class: "alert-heading fw-bold" }
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = {
  key: 2,
  class: "mt-30"
}
const _hoisted_47 = { class: "table-responsive" }
const _hoisted_48 = { class: "table table-hover" }
const _hoisted_49 = { class: "fw-medium" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "badge bg-primary" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = {
  key: 3,
  class: "text-center py-50"
}
const _hoisted_54 = {
  key: 4,
  class: "alert alert-danger mt-20",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ccc = _resolveComponent("ccc")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "fw-bold mb-10" }, "Navires pêche sans licence", -1)),
          _createElementVNode("span", _hoisted_5, " Période: " + _toDisplayString(_ctx.kpiData?.periode?.debut) + " - " + _toDisplayString(_ctx.kpiData?.periode?.fin) + " (" + _toDisplayString(_ctx.kpiData?.periode?.duree_jours) + " jours) ", 1)
        ]),
        (_ctx.kpiData?.resume?.interpretation)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["badge fs-14 fw-bold", _ctx.getBadgeClass(_ctx.kpiData.resume.interpretation.niveau)])
            }, _toDisplayString(_ctx.kpiData.resume.interpretation.niveau), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label fw-medium mb-10" }, "Date de début", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.dateDebut) = $event)),
                  class: "form-control",
                  max: _ctx.filters.dateFin || _ctx.getTodayDate()
                }, null, 8, _hoisted_11), [
                  [_vModelText, _ctx.filters.dateDebut]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label fw-medium mb-10" }, "Date de fin", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.dateFin) = $event)),
                  class: "form-control",
                  min: _ctx.filters.dateDebut,
                  max: _ctx.getTodayDate()
                }, null, 8, _hoisted_13), [
                  [_vModelText, _ctx.filters.dateFin]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                    class: "btn btn-primary flex-grow-1",
                    disabled: _ctx.loading || !_ctx.filters.dateDebut || !_ctx.filters.dateFin
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "flaticon-search me-5" }, null, -1),
                    _createTextVNode(" Filtrer ", -1)
                  ]))], 8, _hoisted_16),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
                    class: "btn btn-outline-secondary",
                    disabled: _ctx.loading
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "flaticon-refresh me-5" }, null, -1),
                    _createTextVNode(" Réinitialiser ", -1)
                  ]))], 8, _hoisted_17)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.kpiData?.resume)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
                        _createElementVNode("i", { class: "flaticon-sterile-box" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, "Total détections", -1)),
                        _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.kpiData.resume.total_detections), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
                        _createElementVNode("i", { class: "flaticon-trolley-cart" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, "Navires uniques ", -1)),
                        _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.kpiData.resume.navires_uniques), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-info" }, [
                        _createElementVNode("i", { class: "flaticon-card" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, "Zones affectées", -1)),
                        _createElementVNode("h4", _hoisted_37, [
                          _createVNode(_component_ccc, {
                            title: "$105",
                            class: "ccc--converted",
                            style: {"font-size":"inherit","display":"inline","color":"inherit"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.kpiData.resume.zones_affectees), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
                        _createElementVNode("i", { class: "flaticon-sugar-cubes" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_42, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Indicateur sévérité", -1)),
                        _createElementVNode("h4", _hoisted_43, [
                          _createVNode(_component_ccc, {
                            title: "$12,345",
                            class: "ccc--converted",
                            style: {"font-size":"inherit","display":"inline","color":"inherit"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.kpiData.resume.indicateur_severite), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.kpiData?.resume?.interpretation)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["alert mt-20", _ctx.getAlertClass(_ctx.kpiData.resume.interpretation.niveau)]),
            role: "alert"
          }, [
            _createElementVNode("h5", _hoisted_44, _toDisplayString(_ctx.kpiData.resume.interpretation.message), 1),
            _createElementVNode("p", _hoisted_45, [
              _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Action recommandée:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.kpiData.resume.interpretation.action), 1)
            ])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.kpiData?.navires?.recidivistes?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "fw-bold mb-15" }, "Top 10 Navires Récidivistes", -1)),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("table", _hoisted_48, [
                _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Nom du navire"),
                    _createElementVNode("th", null, "IMO"),
                    _createElementVNode("th", null, "MMSI"),
                    _createElementVNode("th", null, "Pavillon"),
                    _createElementVNode("th", { class: "text-center" }, "Détections"),
                    _createElementVNode("th", { class: "text-center" }, "Risque max"),
                    _createElementVNode("th", null, "Première détection"),
                    _createElementVNode("th", null, "Dernière détection")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiData.navires.recidivistes.slice(0, 10), (navire) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: navire.dim_navire__mmsi
                    }, [
                      _createElementVNode("td", _hoisted_49, _toDisplayString(navire.dim_navire__nom_navire), 1),
                      _createElementVNode("td", null, _toDisplayString(navire.dim_navire__imo_number || 'N/A'), 1),
                      _createElementVNode("td", null, _toDisplayString(navire.dim_navire__mmsi), 1),
                      _createElementVNode("td", null, _toDisplayString(navire.dim_navire__pavillon), 1),
                      _createElementVNode("td", _hoisted_50, [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(navire.nombre_detections), 1)
                      ]),
                      _createElementVNode("td", _hoisted_52, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.getRisqueBadgeClass(navire.risque_max)])
                        }, _toDisplayString(navire.risque_max), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(navire.premiere_detection)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(navire.derniere_detection)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Erreur:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}